import { render, staticRenderFns } from "./VoteEdit.vue?vue&type=template&id=0ab5d3ee&scoped=true"
import script from "./VoteEdit.vue?vue&type=script&lang=js"
export * from "./VoteEdit.vue?vue&type=script&lang=js"
import style0 from "./VoteEdit.vue?vue&type=style&index=0&id=0ab5d3ee&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab5d3ee",
  null
  
)

export default component.exports